import styles from "./App.module.css";
import {Chat} from "./components/chat/chat";
import Logo from "../../images/logo.svg";
import Image1 from "./images/image1.svg";
import Image2 from "./images/image2.svg";
import Image3 from "./images/image3.svg";

function App() {
  return (
    <div className={styles.page}>
      <img className={styles.logo} src={Logo} alt="Zodiaq" />
      <div className={styles.page_flex_container}>
        <Chat />
        <div className={styles.main_text_container}>
          <div>
            <h1 className={styles.title}>
              Match with Astrologers to get the best advice based on your natal
              chart
            </h1>
            <ul className={styles.main_list}>
              <li>
                Get fascinating insights about your love life,including who
                you’re most compatible with, what’s coming next in your
                relationships, and tips for handling any drama
              </li>
              <li>
                Discover valuable advice for your career and finances, such as
                potential new job opportunities, money-saving tips, and what to
                watch out for in your professional life
              </li>
            </ul>
          </div>
          <div className={styles.advantages}>
            <h2>Our Advantages</h2>
            <div className={styles.advantages_flex}>
              <div className={styles.advantages_item}>
                <img src={Image1} alt=""/>
                <h3>Night & Day</h3>
                <p>Astrologers are available 24/7 to answer your questions in minutes</p>
              </div>
              <div className={styles.advantages_item}>
                <img src={Image2} alt=""/>
                <h3>Unlimited Chats</h3>
                <p>Enjoy a chat with a personal Astrologer and ask as much as you want</p>
              </div>
              <div className={styles.advantages_item}>
                <img src={Image3} alt=""/>
                <h3>Experienced Experts</h3>
                <p>Get answers and professional psychic readings from 300+ rigorously-tested Astrologers</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
